import React, { Component } from 'react'
import { AppContext } from '@lightspeed-invoicing/core-client/frontend'
import Select, { Creatable } from 'react-select'

class LabelSelect extends Component {

    constructor(props, context) {
        super(props, context);
        this.state = {
            options: [],
            type: this.props.type || '',
            creatable: this.props.creatable || false,
            multi: this.props.multi || false
        }
        if (this.state.multi) {
            this.state.selectedOptions = this.props.value || []
        } else {
            this.state.selectedOptions = this.props.value || null
        }

        const defaultCallback = () => { }
        this.name = this.props.name
        this.placeholder = this.props.placeholder
        this.onChange = this.props.onChange || defaultCallback
        this.handleChange = this.handleChange.bind(this)

    }

    handleChange(selectedOptions) {
        let newItem
        if (this.state.multi) {
            newItem = selectedOptions.filter(o => o.value === o.label)[0]
        } else if (selectedOptions) {
            newItem = selectedOptions.value === selectedOptions.label ? selectedOptions : null
        }
        if (newItem) {
            AppContext.getApiClient().post('/labels', {
                "description": '',
                "title": newItem.value,
                "type": this.state.type || 'tag',
            }).then(res => {
                const newOption = {
                    value: res.id,
                    label: res.attributes.title,
                }
                const allOptions = this.state.options
                let options
                if (this.state.multi) {
                    options = selectedOptions.filter(o => o.value !== o.label)
                    options.push(newOption)
                } else {
                    options = newOption
                }
                allOptions.push(newOption)
                this.setState({
                    selectedOptions: options,
                    options: allOptions,
                }, () => {
                    this.valueChanged()
                });
            })
            return
        }
        this.setState({
            selectedOptions: selectedOptions
        }, () => {
            this.valueChanged()
        });
    }

    valueChanged() {
        var val = ''
        var label = ''
        if (this.state.multi) {
            val = this.state.selectedOptions.map(option => option.value)
            label = this.state.selectedOptions.map(option => option.label).join(',')

        } else {
            val = this.state.selectedOptions ? this.state.selectedOptions.value : null
            label = this.state.selectedOptions ? this.state.selectedOptions.label : ''
        }

        this.onChange(val, label)
    }

    loadLabels() {
        AppContext.getApiClient().get('/labels').then(res => {
            const data = this.state.type ? res.data.filter(l => l.attributes.type === this.state.type) : res.data
            this.setState({
                options: data.map(label => {
                    return {
                        value: label.id,
                        label: label.attributes.title
                    }
                }),
            })
        })
    }

    componentDidMount() {
        this.loadLabels()
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.value !== this.state.selectedOptions) {
            this.setState({
                selectedOptions: nextProps.value || []
            })
        }
    }

    render() {
        if (this.state.creatable) {
            return <Creatable
                name={this.name}
                multi={this.state.multi}
                placeholder={this.placeholder}
                value={this.state.selectedOptions}
                onChange={this.handleChange}
                options={this.state.options}
            />
        }
        return (
            <Select
                name={this.name}
                multi={this.state.multi}
                placeholder={this.placeholder}
                value={this.props.value}
                onChange={this.handleChange}
                options={this.state.options}
            />
        )
    }
}

export default LabelSelect





// WEBPACK FOOTER //
// ./src/common/label/selection.component.jsx